const THREE = require('three');
import core from '../../store/quincy/core';
import { MUTATIONS } from '../../store/quincy/definitions';
export default {
  data() {
    return {
      camera: {
        angleX: 270,
        angleY: 180
      },
      cameraDefault: {}
    };
  },
  mounted() {
    Object.assign(this.cameraDefault, this.camera);

    this.$store.subscribe(mutation => {
      if (mutation.type === `quincy/${MUTATIONS.MODEL_LOADED}`) {
        if (this.report && this.report._saved === true) {
          // this.$TOGGLECONTROLS({});
        }
      }
    });
  },
  methods: {
    normalMouseButtons() {
      core.controls.mouseButtons = {
        ORBIT: THREE.MOUSE.LEFT,
        ZOOM: THREE.MOUSE.MIDDLE,
        PAN: THREE.MOUSE.RIGHT
      };
    },
    invertedMouseButtons() {
      core.controls.mouseButtons = {
        ORBIT: THREE.MOUSE.RIGHT,
        ZOOM: THREE.MOUSE.MIDDLE,
        PAN: null
      };
    },
    resetActions() {
      this.cameraActive = false;
      this.drawActive = false;
      this.eraseActive = false;
      core.controls.update(core.clock.getDelta());
    },
    changeCameraPosition(data) {
      this.resetCamera();
      core.camera.position.set(data.x, data.y, data.z);
    },
    resetCamera() {
      this.needToReset = false;
      core.camera.position.set(
        core.initialCam.position.x,
        core.initialCam.position.y,
        core.initialCam.position.z
      );
      core.camera.rotation.set(
        core.initialCam.rotation.x,
        core.initialCam.rotation.y,
        core.initialCam.rotation.z
      );
      core.camera.up = new THREE.Vector3(0, 1, 0);
      core.camera.lookAt(new THREE.Vector3(0, 0, 0));
      const boundingBox = new THREE.Box3();
      boundingBox.setFromObject(core.object);
      boundingBox.getCenter(core.controls.target);
    },
    cameraRotate(rotation) {
      if (this.needToReset) {
        Object.assign(this.camera, this.cameraDefault);
        this.resetCamera();
        return;
      }
      switch (rotation) {
        case 'left': {
          this.rotateX(45);
          break;
        }
        case 'right': {
          this.rotateX(-45);
          break;
        }
        case 'up': {
          this.rotateY(-30);
          break;
        }
        case 'down': {
          this.rotateY(30);
          break;
        }
      }
      this.$debug('rotation', core.camera.rotation);
      this.$debug('position', core.camera.position);
      this.$debug(this.camera.angleX, this.camera.angleY);
    },

    rotateX(dAngle) {
      this.camera.angleX += dAngle;
      this.setCamera(this.camera.angleX, this.camera.angleY);
    },

    rotateY(dAngle) {
      if (
        dAngle + this.camera.angleY < 120 ||
        dAngle + this.camera.angleY > 240
      ) {
        return;
      }
      this.camera.angleY += dAngle;
      this.setCamera(this.camera.angleX, this.camera.angleY);
    },

    setCamera() {
      const zoom = core.constants.CAMERA_ZOOM;
      let radsX = (this.camera.angleX * Math.PI) / 180;
      core.camera.position.x = zoom * Math.cos(radsX);
      core.camera.position.z = zoom * Math.sin(radsX);
      let radsY = (this.camera.angleY * Math.PI) / 180;
      core.camera.position.y =
        core.constants.CAMERA_HEIGHT + zoom * Math.sin(radsY);
    }
  }
};
